<template lang="pug">
.v-aside-collections.aside-collections
	.aside-collections__wrap
		transition(name="show-aside" @after-enter="animationComplete")
			.filter-aside(v-if="items && items.length")
				.filter-aside__overlay(@click.stop="clearItems")
				.filter-aside__inner.scrollbar
					.filter-aside__head
						.filter-aside__title(v-if="name") {{name}}
						button.filter-aside__close(@click.stop="clearItems")
							v-svg-icon.filter-aiside__close-icon(icon="cross")
					.filter-aside__body(v-if="isShow && items && items.length")
						transition-group(tag="div" class="filter-aside__list"
							v-if="items.length"
							@before-enter="onBeforeEnter"
							@enter="onEnter"
							appear
						)
							.filter-aside__item(v-for="(item, index) in items" :key="index" :data-index="index")
								v-detail-aside-card(:data-source="item")
</template>

<script>
	import { mapGetters, mapMutations } from 'vuex';
	import scrollLock from 'scroll-lock';
	import gsap from 'gsap';

	export default {
		data() {
			return {
				isShow: false
			}
		},
		methods: {
			...mapMutations({
				clear: 'previewCollection/clear'
			}),
			clearItems() {
				scrollLock.enablePageScroll(document.querySelectorAll('.filter-aside__inner'));
				this.clear();
			},
			animationComplete() {
				this.isShow = true;
			},
			onBeforeEnter(el) {
				el.style.opacity = 0;
				el.style.scale = 0.4;
			},

			onEnter(el, done) {
				const { index = 3 } = el.dataset;
				gsap.to(el, {
					opacity: 1,
					scale: 1,
					duration: +index / 2 + 0.15,
					ease: "elastic",
					onComplete: done
				})
			},
		},
		computed: {
			...mapGetters({
				items: 'previewCollection/getItems',
				name: 'previewCollection/getName',
			})
		}
	}
</script>